import * as React from 'react';

import { ThemeProvider, useTheme } from '../../../../../../theme';
import { BaggageDelivery as BaggageDeliveryRoot } from '../../../../../../CheckoutAdditionalService/components';

const BaggageDelivery: React.FC = () => {
	const { ServicesAggregationPage: theme } = useTheme('Checkout');

	const icons = ['Baggage/Checked-in'];

	return (
		<ThemeProvider
			value={{ CheckoutAdditionalService: { BaggageDelivery: { baggageDelivery: theme.baggageDelivery } } }}
		>
			<BaggageDeliveryRoot aggregationIcons={icons} aggregationMode />
		</ThemeProvider>
	);
};

export default BaggageDelivery;
